import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './companyLogo.module.css';

export const CompanyLogoSkeleton = ({ className, size }) => (
  <div
    className={classNames(
      styles['generic-company-logo'],
      styles[size],
      className,
      'animate-flicker'
    )}
  />
);

CompanyLogoSkeleton.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'xmedium', 'medium', 'xlarge', 'xxlarge', 'large', 'review-card', '']),
};

CompanyLogoSkeleton.defaultProps = {
  className: '',
  size: '',
};
